import { Box, Text } from '@enechain/ecloud-designsystem'

type Props = {
  done: number
  total: number
}

/**
 * ステップ進捗ミニバー (design/demand/case-detail.html `.bigstep-progress` /
 * `.bigstep-progress-bar` / `.bigstep-progress-fill` 相当)。
 *
 * ケースヘッダー・大ステップアコーディオン行・画面下部 action bar の 3 箇所で
 * 同じ視覚表現を再利用する (= raw div の重複実装を避ける)。
 */
export const StepProgressBar = ({ done, total }: Props): React.ReactElement => {
  const allDone = total > 0 && done === total
  const percent = total > 0 ? Math.round((done / total) * 100) : 0

  return (
    <Box alignItems="center" gap="6px" display="flex">
      <Box
        flexShrink={0}
        overflow="hidden"
        width="80px"
        height="8px"
        background="Surface.secondary"
        borderWidth="1px"
        borderColor="Border.lowEmphasis"
        borderRadius="full"
      >
        <Box
          width={`${percent}%`}
          height="100%"
          background={allDone ? 'Text.positiveMid' : 'Text.infoMid'}
        />
      </Box>
      <Text
        color="Text.midEmphasis"
        fontSize="sm"
        fontVariantNumeric="tabular-nums"
      >
        {done} / {total}
      </Text>
    </Box>
  )
}
